<template>
  <div id="GenerlInfoView">
    <v-card outlined>
      <v-card-text v-show="!registerModel.taxId">
        <v-skeleton-loader type="article"></v-skeleton-loader>
      </v-card-text>
      <v-card-text v-show="registerModel.taxId">
        <div class="general-viwe-layout">
          <h4>{{ $t("vendor.typeVendor") }}</h4>
          <p>{{ registerModel.vendorType }}</p>
          <h4>{{ $t("vendor.commercialType") }}</h4>
          <p>{{ registerModel.commercialTypeName }}</p>
          <h4 v-show="isShow">{{ $t("vendor.commercialPrefix") }}</h4>
          <p v-show="isShow">{{ registerModel.commercialPrefixName }}</p>
          <h4>{{ $t("vendor.companyNameEn") }}</h4>
          <p>{{ registerModel.companyNameEn }}</p>
          <h4 v-if="registerModel.vendorType === 'domestic'">
            {{ $t("vendor.companyNameTh") }}
          </h4>
          <p v-if="registerModel.vendorType === 'domestic'">
            {{ registerModel.companyNameTh }}
          </p>
          <h4 v-if="registerModel.vendorType === 'domestic'">
            {{ $t("vendor.taxId") }}
          </h4>
          <p v-if="registerModel.vendorType === 'domestic'">
            {{ registerModel.taxId }}
          </p>
          <h4 v-if="registerModel.vendorType === 'domestic'">
            {{ $t("vendor.branchId") }}
          </h4>
         <p v-if="registerModel.vendorType === 'domestic' && registerModel.branchId !='—'">
            {{  registerModel.branchId }}
          </p>
          <p v-else>00000</p>
          
          <div class="line"></div>
          <h4>{{ $t("vendor.address") }}</h4>
          <p>{{ registerModel.sapHouseNum1 }}</p>
          <h4 v-if="registerModel.vendorType === 'domestic'">
            {{ $t("vendor.moo") }}
          </h4>
          <p v-if="registerModel.vendorType === 'domestic'">
            {{ registerModel.sapStreet }}
          </p>
          <h4 v-if="registerModel.vendorType === 'domestic'">
            {{ $t("vendor.alley") }}
          </h4>
          <p v-if="registerModel.vendorType === 'domestic'">
            {{ registerModel.sapStrSuppl1 }}
          </p>
          <h4>{{ $t("vendor.street") }}</h4>
          <p>{{ registerModel.sapStrSuppl3 }}</p>
          <h4>{{ $t("vendor.state") }}</h4>
          <p>{{ registerModel.sapCity2 }}</p>
          <h4>{{ $t("vendor.city") }}</h4>
          <p>{{ registerModel.sapStrSuppl2 }}</p>
          <h4>{{ $t("vendor.zipcode") }}</h4>
          <p>{{ registerModel.sapPostCode1 }}</p>
          <h4 v-if="isShowProvince">{{ $t("vendor.province") }}</h4>
          <p v-if="isShowProvince">{{ registerModel.provinceName }}</p>
          <h4>{{ $t("vendor.country") }}</h4>
          <p>{{ registerModel.countryName }}</p>

          <div class="line"></div>
          <h4>{{ $t("vendor.companyEstablishDate") }}</h4>
          <p>{{ registerModel.companyEstablishDate }}</p>
          <h4>{{ $t("vendor.companyTurnOver") }}</h4>
          <p>{{ number(registerModel.companyTurnOver) }} {{ registerModel.currency }}</p>
          <h4>{{ $t("vendor.companyTurnOverDate") }}</h4>
          <p>{{ registerModel.companyTurnOverDate }}</p>

          <h4>{{ $t("vendor.fxrate") }}</h4>
          <p>{{ registerModel.fxrate }}</p>

          <h4>{{ $t("vendor.thbath") }}</h4>
          <p>{{ number(registerModel.thbath) }}</p>

          <h4>{{ $t("vendor.numberofEmployees") }}</h4>
          <p>{{ fucFormatter(registerModel.numberofEmployees) }}</p>
          <h4>{{ $t("vendor.companyWebSite") }}</h4>
          <a :href="`http://${registerModel.companyWebSite}`">{{
            registerModel.companyWebSite
          }}</a>

          <h4>{{ $t("vendor.tel") }}</h4>
          <p>{{ registerModel.companyTelephone }}</p>
        
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "GenerlInfoView",
  props: {
    propModel: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      registerModel: {},
    };
  },
  computed: {
    isShow() {
      if (this.registerModel.commercialTypeId == "2") {
        return true;
      } else {
        return false;
      }
    },
    isShowProvince() {
      if (this.registerModel.countryId == "221") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    propModel(value) {
      if (!this.isEmpty(value)) {
        this.checkNull(value);
      }
    },
  },
  mounted() {
    if (!this.isEmpty(this.propModel)) {
      this.checkNull(this.propModel);
    }
  },
  methods: {
    number(number) {
      if (number != null)
      {
          const num = parseFloat(number);
          return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    checkNull(obj) {
      Object.keys(obj).forEach(function (key) {
        if (obj[key] === "" || obj[key] === null) {
          obj[key] = "—";
        }
      });

      const resDate = obj.companyEstablishDate.substring(0, 10);
      const resDate2 = obj.companyTurnOverDate.substring(0, 10);
      obj.companyTurnOverDate=resDate2;
      obj.companyEstablishDate = resDate;
      this.registerModel = obj;
      
    },
    isEmpty(obj) {
      for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(prop)) {
          return false;
        }
      }
      return JSON.stringify(obj) === JSON.stringify({});
    },
    fucFormatter(numer) {
      const formatter = new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: "THB",
        minimumFractionDigits: 0,
      });
      if(formatter.format(+numer) === null){
        return "0";
      }else{
        return formatter.format(+numer).substring(1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.general-viwe-layout {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 1rem;
  row-gap: 0.7rem;
  width: 100%;
  @media only screen and (min-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  > h4 {
    color: #103a5d;
    font-weight: 500;
    grid-column: 1/2;
    font-size: 14px;
    margin: 0;
    > span {
      color: red;
    }
    @media only screen and (min-width: 600px) {
      grid-column: 1/2;
    }
  }
  > p {
    color: #555555;
    margin: 0;
  }
  > a {
    color: #555555;
  }
  > .line {
    grid-column: 1/2;
    border-bottom: 1px solid #e5e5e5;
    @media only screen and (min-width: 600px) {
      grid-column: 1/3;
    }
  }
  > .full {
    grid-column: 1/2;
    display: grid;
    grid-template-columns: 5rem 1fr;
    @media only screen and (min-width: 600px) {
      grid-column: 1/3;
    }
    > h4 {
      color: #103a5d;
      font-weight: 500;
      grid-column: 1/2;
      font-size: 14px;
      margin: 0;
      > span {
        color: red;
      }
      @media only screen and (min-width: 600px) {
        grid-column: 1/2;
      }
    }
    > p {
      color: #555555;
      margin: 0;
      > span {
        color: #103a5d;
      }
    }
  }
}
</style>
